
import React from 'react';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { Shield } from 'lucide-react';

export const PermissionsTab: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between space-x-2">
        <div className="space-y-0.5">
          <div className="flex items-center">
            <Lock className="h-5 w-5 mr-2 text-primary" />
            <h3 className="font-medium text-lg">Permissions & Access Control</h3>
          </div>
          <p className="text-muted-foreground text-sm">
            Define role-based access control and permissions
          </p>
        </div>
      </div>
      
      <Separator />
      
      <div className="border rounded-md p-6 bg-muted/50">
        <div className="flex items-center justify-center h-24">
          <div className="text-center">
            <p className="text-muted-foreground mb-2">This feature requires additional configuration</p>
            <Button variant="outline" disabled className="gap-1">
              <Shield className="h-4 w-4" />
              Setup RBAC
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
